import A from '../actions/formUtilsActions';
import { getRules } from '../../utils/formValidationUtils';

export default (state={}, action) => { switch(action.type) {
    case A.FORM_UTILS_ADD_NEW_FORM_ENTRY: return {...state, [action.payload]: {} };

    case A.FORM_UTILS_BUILD_FORM_FROM_OBJECT: return (props => {
        const { key, fieldsObj } = props;
        let formData = {};

        // Get the default values by the type in the config.
        for(let o in fieldsObj) {
            let config = fieldsObj[o];
            formData[o] = { 
                rules: getRules(config.rules),
                value: getDefaultByType(config.type),
                valid: null,
                form: {
                    hasFeedback: config.hasFeedback || true,
                    help: config.help || '',
                    validateStatus: config.validateStatus || '',
                    label: config.label || '',
                    required: config.optional != null ? config.optional : true
                }
            };
        };

        return {...state, [key]: formData };
    })(action.payload)

    case A.FORM_UTILS_VALIDATE_FORM_FIELD: return (props => {
        const { key, field } = props;

        let 
        invalid = false,
        formResult = [],
        formData = {...state[key]},
        formField = formData[field];

        // Run all the validation functions and place the results in 'formResult'.
        for(let r in formField.rules)
            formResult.push(formField.rules[r](formField.value));

        for(let r in formResult)
            // If there was a false value, use the returned result to update the form field props.
            if(!formResult[r].valid) {
                let result = formResult[r];
                invalid = true;
                formField.valid = result.valid;
                formField.form.help = result.help;
                formField.form.validateStatus = result.validateStatus;
                break;
            }

        // If not 'invalid' set the form feedback information.
        if(!invalid) {
            formField.valid = true;
            formField.form.help = '';
            formField.form.validateStatus = 'success';
        }

        return {...state, [key]: formData};
    })(action.payload)

    case A.FORM_UTILS_SET_FIELD_FORM_VALUE: return (props => {
        const { key, field, value } = props;
        return {...state, [key]: {...state[key], [field]: {...state[key][field], value }}};
    })(action.payload)

    case A.FORM_UTILS_SET_FIELD_FORM_RULES: return (props => {
        const { key, field, rules } = props;
        return {...state, [key]: {...state[key], [field]: {...state[key][field], rules }}};
    })(action.payload)

    default: return {...state};
}}

const getDefaultByType = type => { switch(type) {
    case 'input': return '';
    case 'select': return [];
    case 'date-picker': return undefined;
    case 'check': return undefined;
    default: return null;
}}